'use client';
import { useSocketData } from '@/lib/hooks/useSocketData';

export function WebsocketClient() {
  useSocketData();

  return null;
}
